import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-edit-assessment',
  templateUrl: './edit-assessment.component.html',
  styleUrls: ['./edit-assessment.component.css']
})
export class EditAssessmentComponent implements OnInit, OnDestroy {
  formId: any;
  editAssessmentID: any;
  viewAsseessmentData: any = [];
  programList: any = [];
  editAssessmentTitleForm: FormGroup;
  editAssessmentForm: FormGroup;
  editAssessmentArrData: any = [];
  viewAssessmentAPI: Subscription | any;

  constructor(private activatedroute: ActivatedRoute, private fb: FormBuilder, private router: Router,
    public service: MainService) {
    this.editAssessmentTitleForm = new FormGroup({
      "addassessmentTitle": new FormControl('', Validators.required),
      "addassessmentTitleFR": new FormControl(''),
      "addassessmentTitleES": new FormControl(''),
      "addAssessmentProgramValue": new FormControl('', Validators.required)
    });
    this.editAssessmentForm = this.fb.group({
      'assessmentText': [''],
      // 'marks' : [''],
      'QueArr4': this.fb.array([]),
      remarks: this.fb.array([])
    })
    this.activatedroute.params.subscribe((res) => {
      this.formId = res.id
    });
  }

  ngOnInit() {
    this.viewProgramList();
    this.editViewAssessment(this.formId);
  }

  viewProgramList() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.programList, 1).subscribe((res) => {
      this.service.hideSpinner();

      if (res.responseCode == 200) {
        this.programList = res.result;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  addUser4(QueArr?: any, i?: any) {
    // this.queNumber1 =this.queNumber1+1;
    let fg = this.fb.group({
      'assessmentText': [QueArr ? QueArr.assessmentText : '', Validators.compose([Validators.required])],
      'assessmentTextFR': [QueArr ? QueArr.assessmentText : ''],
      'assessmentTextES': [QueArr ? QueArr.assessmentText : ''],
      // 'marks' : [QueArr? QueArr.marks : '' ,Validators.compose([Validators.required])]
    });
    (<FormArray>this.editAssessmentForm.get('QueArr4')).push(fg);
  }

  addRemark4() {
    let fg = this.fb.group({
      'remark': [''],
      'remarkFR': [''],
      'remarkES': [''],
    });
    (<FormArray>this.editAssessmentForm.get('remarks')).push(fg);
  }

  deleteUser4(index: number) {
    (<FormArray>this.editAssessmentForm.get('QueArr4')).removeAt(index);
  }
  deleteRemark4(index: number) {
    (<FormArray>this.editAssessmentForm.get('remarks')).removeAt(index);
  }

  editViewAssessment(id: any) {
    this.editAssessmentID = id;
    this.viewAssessmentAPI = this.service.getApi(ApiUrls.assessmentForm_view + `?formId=${id}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.viewAsseessmentData = res.result
        this.programList.forEach((ele: any) => {
          if (this.viewAsseessmentData.programId == ele._id) {
            this.viewAsseessmentData['programTitle'] = ele.title;
          }
        });
        this.editAssessmentTitleForm.patchValue({
          addassessmentTitle: this.viewAsseessmentData.title,
          addassessmentTitleFR: this.viewAsseessmentData.titleFR,
          addassessmentTitleES: this.viewAsseessmentData.titleES,
          addAssessmentProgramValue: this.viewAsseessmentData.programId
        })

        this.viewAsseessmentData.Questions.forEach((ele: any) => {
          let fg = this.fb.group({
            'assessmentText': ele.QuestionText,
            'assessmentTextFR': ele.QuestionTextFR,
            'assessmentTextES': ele.QuestionTextES,
            // 'marks' :  ele.marks,
          });
          (<FormArray>this.editAssessmentForm.get('QueArr4')).push(fg);
        });

        if (this.viewAsseessmentData.remarks.length === 0) {
          this.addRemark4();
        }
        else {
          this.viewAsseessmentData.remarks.forEach((ele: any, index: number) => {
            let fg = this.fb.group({
              'remark': ele,
              'remarkFR': this.viewAsseessmentData.remarksFR[index],
              'remarkES': this.viewAsseessmentData.remarksES[index]
            });
            (<FormArray>this.editAssessmentForm.get('remarks')).push(fg);
          });
        }

      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  updateAssessmentApi() {

    if (this.editAssessmentTitleForm.value.addAssessmentProgramValue == '') {
      this.service.warningToast('Please select your program');
      return
    }
    this.editAssessmentForm.value.QueArr4.forEach((element: any) => {
      if (element.assessmentText == '') {
        this.service.warningToast('Please type your question');
        return
      }
    });
    if (this.editAssessmentForm.value.QueArr4.length > 0) {
      this.editAssessmentForm.value.QueArr4.forEach((ele: any, index: number) => {
        if (this.editAssessmentArrData.length >= 0) {
          if (ele['assessmentText']) {
            ele['QuestionText'] = ele['assessmentText'];
            delete ele['assessmentText']
          }
          if (ele['assessmentTextFR'] !== undefined && ele['assessmentTextFR'] !== null) {
            ele['QuestionTextFR'] = ele['assessmentTextFR'];
          }
          delete ele['assessmentTextFR']
          if (ele['assessmentTextES'] !== undefined && ele['assessmentTextES'] !== null) {
            ele['QuestionTextES'] = ele['assessmentTextES'];
          }
          delete ele['assessmentTextES']
          ele['QuestionNumber'] = index + 1;
          ele['QuestionType'] = 'YESNO';
          ele.marks = 1;

          this.editAssessmentArrData.push(ele);
        }
      });
      var concatArray = this.editAssessmentArrData
    } else {
      this.editAssessmentArrData = [];
      this.editAssessmentArrData = this.editAssessmentForm.value.QueArr4[0];
    }
    let remarkArrData: any = [], remarkArrDataFR: any = [], remarkArrDataES: any = [];

    this.editAssessmentForm.value.remarks.forEach((element: any) => {
      if (element['remark'].toString().trim() !== '') {
        remarkArrData.push(element['remark']);
        if (element['remarkFR'] !== null) {
          remarkArrDataFR.push(element['remarkFR']);
        }
        if (element['remarkES'] !== null) {
          remarkArrDataES.push(element['remarkES']);
        }
      }
    });


    if (this.editAssessmentTitleForm.value.addAssessmentProgramValue != '' && this.editAssessmentForm.valid) {
      if (this.editAssessmentTitleForm.value.addassessmentTitle == '') {
        this.service.errorToast('Title is required');
        return
      }

      const data: any = {
        programId: this.editAssessmentTitleForm.value.addAssessmentProgramValue,
        title: this.editAssessmentTitleForm.value.addassessmentTitle,
        Questions: concatArray,
        remarks: remarkArrData
      }
      if (this.editAssessmentTitleForm.value.addassessmentTitleFR !== undefined && this.editAssessmentTitleForm.value.addassessmentTitleFR !== null && this.editAssessmentTitleForm.value.addassessmentTitleFR.length > 0) {
        data["titleFR"] = this.editAssessmentTitleForm.value.addassessmentTitleFR;
      }
      if (this.editAssessmentTitleForm.value.addassessmentTitleES !== undefined && this.editAssessmentTitleForm.value.addassessmentTitleES !== null && this.editAssessmentTitleForm.value.addassessmentTitleES.length > 0) {
        data["titleES"] = this.editAssessmentTitleForm.value.addassessmentTitleES;
      }
      if (remarkArrDataFR.length > 0) {
        data["remarksFR"] = remarkArrDataFR;
      }
      if (remarkArrDataES.length > 0) {
        data["remarksES"] = remarkArrDataES;
      }
      this.service.showSpinner();
      this.service.putApi(ApiUrls.editAssessment_Form + `?formId=${this.editAssessmentID}`, data, 1).subscribe((res) => {
        this.service.hideSpinner();
        if (res.responseCode === 200) {
          this.editAssessmentArrData = [];
          concatArray = [];
          this.service.successToast(res.responseMessage);
          this.editAssessmentForm.reset();
          this.editAssessmentTitleForm.reset();
          const data1 = {
            tabView: "Assessments",
            acion: "view"
          }
          this.router.navigate(['assessment'], { queryParams: { value: JSON.stringify(data1) } })
        }
        else {
          this.editAssessmentArrData = [];
          concatArray = []
          this.editAssessmentForm.value.QueArr4.clear();

          this.editAssessmentForm.reset();
          this.editAssessmentTitleForm.reset();
          this.service.errorToast(res.responseMessage)
        }

      }, err => {
        this.service.hideSpinner();
        this.service.errorToast(err.responseMessage)
      })
    } else {
      this.service.errorToast('Fill the all details')
    }

  }

  ngOnDestroy() {
    this.viewAssessmentAPI.unsubscribe()
  }

  back() {
    const data1 = {
      tabView: "Assessments",
      acion: "view"
    }
    this.router.navigate(['assessment'], { queryParams: { value: JSON.stringify(data1) } })
  }

}
